import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/login'),
        meta: {
            title: '大印家谱-登录'
        },

        redirect: '/login',
        children: [
            {
                path: '/login',
                name: 'Login',
                component: () => import('@/views/login/login'),
                meta: {
                    title: '大印家谱-登录'
                }
            },
            {
                path: '/register',
                name: 'Register',
                component: () => import('@/views/login/register'),
                meta: {
                    title: '大印家谱-注册'
                }
            },
            {
                path: '/resetPwd',
                name: 'ResetPwd',
                component: () => import('@/views/login/resetPwd'),
                meta: {
                    title: '大印家谱-重置密码'
                }
            }
        ]
    },
    {
        path: '/',
        name: '/',
        component: () => import('../indexs'),
        meta: {
            title: '大印家谱-首页'
        },
        redirect: '/home',
        children: [
            {
                path: '/home',
                name: 'Home',
                component: () => import('@/views/home'),
                meta: {
                    title: '大印家谱-首页'
                }
            }
        ]
    },
    {
        path: '/m',
        name: 'm',
        component: () => import('../layout'),
        meta: {
            title: '大印家谱-家谱编辑'
        },
        redirect: '/homePage',
        children: [
            {
                path: '/homePage',
                name: '/homePage',
                component: () => import('@/views/homePage/index.vue'),
                meta: {
                    title: '大印家谱-家谱编辑'
                }
            },
            {
                path: '/userInfo',
                name: '/userInfo',
                component: () => import('@/views/userInfos/index.vue'),
                meta: {
                    title: '大印家谱-个人信息'
                },
                redirect: '/userInfo/userInfo',
                children: [
                    {
                        path: 'userInfo',
                        name: 'userInfo',
                        component: () => import('@/views/userInfos/userInfo/index.vue'),
                        meta: {
                            title: '大印家谱-个人信息'
                        }
                    },
                    {
                        path: 'userProducts',
                        name: 'userProducts',
                        component: () => import('@/views/userInfos/userProducts/index.vue'),
                        meta: {
                            title: '大印家谱-输出套餐'
                        }
                    },
                    {
                        path: 'userOrder',
                        name: 'userOrder',
                        component: () => import('@/views/userInfos/userOrder/index.vue'),
                        meta: {
                            title: '大印家谱-我的订单'
                        }
                    },
                    {
                        path: 'userRetail',
                        name: 'userRetail',
                        component: () => import('@/views/userInfos/userRetail/index.vue'),
                        meta: {
                            title: '大印家谱-代理分销'
                        }
                    },
                    {
                        path: 'userPassword',
                        name: 'userPassword',
                        component: () => import('@/views/userInfos/userPassword/index.vue'),
                        meta: {
                            title: '大印家谱-修改密码'
                        }
                    },
                    {
                        path: 'vips',
                        name: 'Vips',
                        component: () => import('@/views/userInfos/vips/index.vue'),
                        meta: {
                            title: '大印家谱-VIP升级'
                        }
                    }
                ]
            },

            {
                path: '/pedigree',
                name: 'Pedigree',
                component: () => import('@/views/pedigree/index.vue'),
                meta: {
                    title: '大印家谱-谱系编辑'
                }
            },
            {
                path: '/pedigreeDetail',
                name: 'PedigreeDetail',
                component: () => import('@/views/pedigreeDetails/index.vue'),
                meta: {
                    title: '大印家谱-谱系详情'
                }
            },
            {
                path: '/spectrums',
                name: 'Spectrums',
                component: () => import('@/views/spectrums/index.vue'),
                meta: {
                    title: '大印家谱-谱文编辑'
                }
            },
            {
                path: '/books',
                name: 'Books',
                component: () => import('@/views/books/index.vue'),
                meta: {
                    title: '大印家谱-谱书编辑'
                }
            },
            {
                path: '/bookDetails',
                name: 'BookDetails',
                component: () => import('@/views/bookDetails/index.vue'),
                meta: {
                    title: '大印家谱-谱书编辑'
                }
            },
            {
                path: '/bookConfigs',
                name: 'BookConfigs',
                component: () => import('@/views/bookConfigs/index.vue'),
                meta: {
                    title: '大印家谱-谱书样式'
                }
            },
            {
                path: '/printPreview',
                name: 'PrintPreview',
                component: () => import('@/views/printPreview/index.vue'),
                meta: {
                    title: '大印家谱-谱书预览'
                }
            },
            {
                path: '/prints',
                name: 'Prints',
                component: () => import('@/views/prints/index.vue'),
                meta: {
                    title: '大印家谱-谱书预览'
                }
            },
            {
                path: '/printImg',
                name: 'PrintImg',
                component: () => import('@/views/printImg/index.vue'),
                meta: {
                    title: '大印家谱-谱书预览'
                }
            }
        ]
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
